import { render, staticRenderFns } from "./AjusteEstoqueBI.vue?vue&type=template&id=2ed94bad"
import script from "./AjusteEstoqueBI.vue?vue&type=script&lang=js"
export * from "./AjusteEstoqueBI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports